import avatarPath from 'assets/images/artist-default.svg'

export const getCoverImagePath = (productId: any) =>
  productId ? `${process.env.REACT_APP_COVERS_URL}/covers/${productId}` : avatarPath
